import { Modal, Tooltip } from "@nextui-org/react";

import React, { useState, useEffect } from "react";
import fetchData from "utils/fetchData";
import { BsTrashFill } from "react-icons/bs";
import SelectFolder from "./SelectFolder";
import Confirm from "./Confirm";
import { toast } from "react-toastify";


const Upload = ({ onSuccess, folders_id, users_id, notif, client }) => {
    const [files, setFiles] = useState([]);
    const [description, setDescription] = useState("");
    const [month, setMonth] = useState(getMonth());
    const [year, setYear] = useState(getYear());
    const [file, setFile] = useState(null);
    const [currentFolder, setCurrentFolder] = useState(null);
    const [clients, setClients] = useState([]);

    useEffect(() => {

        const get_clients = async () => {
            const { data, error } = await fetchData({ url: "users?roles_id=1" });
            if (!error) setClients(data);
        }

        if (client) get_clients()
    }, [client]);

    const destroyFile = (file) => {
        const new_files = [...files].filter(item => item.name !== file.name);
        setFiles(new_files);
    }

    const submit = async e => {
        e.preventDefault();
        if (!files.length) toast.error("Déposez au minimum un fichier")

        const { data, error } = await fetchData({
            url: "documents",
            method: "post",
            files: files,
            body: {
                description: description,
                folders_id: folders_id || currentFolder,
                users_id: client ? document.getElementById("client").value : users_id,
                year: year,
                month: month
            },
            loading: true
        })
        if (error) return;

        if (onSuccess) onSuccess([...data]);
        setFiles([]);
    }

    const handleFile = (e) => {
        if (e.target.files.length === 0) return;
        const types = ["png", "jpg", "jpeg", "svg"];
        const test = types.some(type => e.target.files[0].type.includes(type));
        if (e.target.files.length === 1 && test) {
            setFile(e.target.files[0]);
            e.target.value = null;
            return;
        }
        setFiles([...files, ...e.target.files])
        e.target.value = null;
    }

    return (
        <form className="upload" onSubmit={submit}>
            <div className="group">
                <label>Fichiers</label>
                <input id="file-input" type="file" name="file" multiple onChange={handleFile} />
            </div>

            <span>

                <div className="group">
                    <label>Objet de l'envoie</label>
                    <input
                        type="text"
                        placeholder="Objet de l'envoie"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}

                    />
                </div>

                <div className="group">
                    <label>Année et mois</label>
                    <input
                        required
                        className="input"
                        type="month"
                        id="start"
                        name="start"
                        max={getDate()}
                        min="2010-03"
                        value={year + "-" + month}
                        onChange={e => {
                            const m = e.target.value.split("-")[1];
                            const y = e.target.value.split("-")[0];
                            setMonth(m);
                            setYear(y);
                        }}
                    />
                </div>

            </span>

            {(client) && <div className="group">
                <label>Client</label>
                <select required id="client" value={""}>
                    <option value={""}></option>
                    {clients.map((client) => <option key={client.id} value={client.id}>{client.name}</option>)}
                </select>
            </div>}

            {!Boolean(folders_id) && (
                <div className="group">
                    <label htmlFor="id">Dossier cible</label>
                    <SelectFolder
                        folder={currentFolder}
                        setFolder={setCurrentFolder}
                        id="folder"
                    />
                </div>
            )}

            {(Boolean(notif) && false) && <label className="switch">
                <input className="switch__input" type="checkbox" />
                <i className="switch__icon"></i>
                <span className="switch__span">Informer par mail le client du dépôt de fichier</span>
            </label>}

            <button style={{ margin: "20px" }} type="submit">
                {files.length <= 1 ? "Envoyer le fichier" : `Envoyer les ${files.length} fichiers`}
            </button>

            {(Boolean(files.length)) && <div style={{ width: "100%" }} className="card">
                {files.map(file => <div style={{ justifyContent: "space-between", display: "flex" }}>
                    <p>{file.name}</p>
                    <Tooltip content="Supprimer" color="error" >
                        <BsTrashFill onClick={() => destroyFile(file)} size={24} fill="#FF0080" />
                    </Tooltip>
                </div>)}
            </div>}

            <Modal
                className="card"
                closeButton
                aria-labelledby="modal-title"
                open={file !== null}
                onClose={() => setFile(null)}
                width="600px"
                scroll>

                <Confirm setFile={setFile} file={file} setFiles={setFiles} />

            </Modal>

        </form>
    )
}

function getMonth(date = new Date) {
    let month = date.getMonth() + 1;

    if (month < 10) month = "0" + month;

    return month.toString();
}

function getYear(date = new Date) {
    return date.getFullYear();
}

function getDate(date = new Date) {
    let year = getYear(date)
    let month = getMonth(date);

    return [year, month].join('-');
}

export default Upload;